__turbopack_context__.v({
  "container": "EBoutiqueServices-module-scss-module__YyzlmW__container",
  "description": "EBoutiqueServices-module-scss-module__YyzlmW__description",
  "grid": "EBoutiqueServices-module-scss-module__YyzlmW__grid",
  "heading": "EBoutiqueServices-module-scss-module__YyzlmW__heading",
  "icon": "EBoutiqueServices-module-scss-module__YyzlmW__icon",
  "section": "EBoutiqueServices-module-scss-module__YyzlmW__section",
  "service": "EBoutiqueServices-module-scss-module__YyzlmW__service",
  "text": "EBoutiqueServices-module-scss-module__YyzlmW__text",
  "title": "EBoutiqueServices-module-scss-module__YyzlmW__title",
});
